<div class="title_div">
    <div class="w-100 d-flex justify-content-between align-items-center">
        <!-- <div class="title_sub_div_1 mt-1">Dashboard</div> -->
        <div class="title_sub_div_1 mt-1">Create {{ userType | titlecase }}</div>
        <div class="title_sub_div_1 title_right_icon_div mr-1">
            <!-- <i class="fa fa-refresh" (click)="refreshPage()" title="Refresh dashboard data"></i> -->
        </div>
    </div>
</div>
<div class="container">
    <div class="card">
        <div class="card_main">
            <form [formGroup]="registerForm" (ngSubmit)="register()">
                <div class="d-flex justify-content-left" title="Choose Manager or Engineer">
                    <div class="toggle-buttons">
                        <button type="button" (click)="setRole('Manager')"
                            [class.active]="registerForm.get('role_id')?.value === 'Manager'">
                            Manager
                        </button>
                        <button type="button" (click)="setRole('Engineer')"
                            [class.active]="registerForm.get('role_id')?.value === 'Engineer'">
                            Engineer
                        </button>
                    </div>
                </div>

  

                <div class="row mt-3">
                    <div class="col-md-6">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="First Name *"
                                formControlName="first_name" (blur)="trimInput('first_name')">
                            <small
                                *ngIf="registerForm.get('first_name')?.invalid && registerForm.get('first_name')?.touched"
                                class="text-danger">
                                First Name is required
                            </small>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Last Name *"
                                formControlName="last_name" (blur)="trimInput('last_name')">
                            <small
                                *ngIf="registerForm.get('last_name')?.invalid && registerForm.get('last_name')?.touched"
                                class="text-danger">
                                Last Name is required
                            </small>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group">
                            <input type="email" class="form-control" placeholder="Your Email *" formControlName="email"
                                (blur)="trimInput('email')">
                            <small *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched"
                                class="text-danger">
                                Valid email is required
                            </small>
                        </div>
                    </div>

                    

                    <div class="col-md-6">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Your Phone (10 digits)"
                                formControlName="phone" (blur)="trimInput('phone')">
                            <small *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched"
                                class="text-danger">
                                Enter a valid 10-digit phone number
                            </small>
                        </div>
                    </div>

                    <!-- <div class="col-md-6">
                    <div class="form-group position-relative">
                        <input [type]="showConfirmPassword ? 'text' : 'password_hash'" class="form-control"
                            placeholder="Confirm Password *" formControlName="confirmPassword">
                        <small *ngIf="registerForm.hasError('mismatch') && registerForm.get('confirmPassword')?.touched"
                            class="text-danger">
                            Passwords do not match
                        </small>
                        <i class="eye-icon" (click)="togglePasswordVisibility('confirmPassword')">
                            <i [ngClass]="showConfirmPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                        </i>
                    </div>
                </div> -->

<!-- 

                    <div class="col-md-6">
                        <div class="form-group">
                            <input type="username" class="form-control" placeholder="Your username *"
                                formControlName="username" (blur)="trimInput('username')">
                            <small
                                *ngIf="registerForm.get('username')?.invalid && registerForm.get('username')?.touched"
                                class="text-danger">
                                Valid username is required
                            </small>
                        </div>
                    </div> -->

                    <div class="col-md-6">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Your username *"
                                formControlName="username" (input)="checkUsernameExists()" (blur)="trimInput('username')">
                            <small class="text-danger" *ngIf="isUsernameTaken">
                                Username already exists
                            </small>
                            <small *ngIf="registerForm.get('username')?.invalid && registerForm.get('username')?.touched && !isUsernameTaken"
                                class="text-danger">
                                Valid username is required
                            </small>
                        </div>
                    </div>

                    

                    <!-- <div class="col-md-6">
                        <div class="form-group position-relative">
                            <input [type]="'text'" class="form-control password-input"
                            [style.webkitTextSecurity]="showPassword ? 'none' : 'disc'"
                            placeholder="Password *" formControlName="password_hash">
                            <small
                                *ngIf="registerForm.get('password_hash')?.invalid && registerForm.get('password_hash')?.touched"
                                class="text-danger">
                                Password must be at least 6 characters
                            </small>
                            <i class="eye-icon" (click)="togglePasswordVisibility('password_hash')">
                                <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                            </i>
                        </div>
                    </div> -->

                    <div class="col-md-6">
                        <div class="form-group position-relative">
                            <input #passwordInput [type]="'text'" class="form-control password-input"
                                [style.webkitTextSecurity]="showPassword ? 'none' : 'disc'"
                                placeholder="Password *" formControlName="password_hash">
                            <small *ngIf="registerForm.get('password_hash')?.invalid && registerForm.get('password_hash')?.touched"
                                class="text-danger">
                                Password must be at least 6 characters
                            </small>
                            <!-- <i class="eye-icon " (click)="togglePasswordVisibility(passwordInput)"
                                [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'">
                            </i> -->

                            <i class="eye-icon" (click)="togglePasswordVisibility(passwordInput)">
                                <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                            </i>
                        </div>
                    </div>

                    
                    



                    <!-- Reporting Manager Dropdown (Only for Engineer Role) -->
                    <div class="col-md-6" *ngIf="registerForm.get('role_id')?.value === 'Engineer'">
                        <div class="form-group">
                            <select class="form-control" formControlName="reportingManager">
                                <option value="" disabled>Select Reporting Manager</option>

                                <option *ngFor="let manager of managersList" [value]="manager.user_id">{{
                                    manager.username }}</option>

                            </select>
                            <small
                                *ngIf="registerForm.get('reportingManager')?.invalid && registerForm.get('reportingManager')?.touched"
                                class="text-danger">
                                Reporting Manager is required
                            </small>
                        </div>
                    </div>

                </div>

                <div class="text-center">
                    <!-- <button type="submit" class="btn btn-outline-primary btn-sm form-group" 
                                            [disabled]="registerForm.invalid">Register</button> -->
                    <button type="submit" class="btn btn-outline-primary btn-sm form-group">
                        {{ isEditMode ? 'Update' : 'Register' }}
                    </button>
                </div>
            </form>


            <div class="table-responsive mt-3">
                <table class="table table-striped custom-hover">
                    <thead>
                        <tr>
                            <th>Sl.No</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>User Name</th>

                            <th>Phone</th>
                            <!-- <th>Password</th> -->
                            <th>Role</th>
                            <th>Reporting Manager</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of userDetails; let i = index">
                            <td>{{ i+1 }}</td>
                            <td>{{ data?.first_name }}</td>
                            <td>{{ data?.last_name }}</td>
                            <td>{{ data?.email }}</td>
                            <td>{{ data?.username }}</td>

                            <td>{{ data?.phone }}</td>
                            <!-- <td>{{ data?.password_hash }}</td> -->
                            <td>{{ data?.role_name }}</td>
                            <td>{{ data?.manager_name }}</td>
                            <td>
                                <!-- <button class="btn btn-danger btn-sm" > -->
                                <i class="fa fa-pencil-alt" aria-hidden="true" (click)="editRow(data, i)"
                                    title="Edit Row Data"></i>
                                <i class="fa fa-trash ml-2" (click)="deleteUser(data,i)"></i>
                                <!-- </button> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>